import storeService from '@/store/store.service';
import { Store } from '@whiz-cart/node-shared/models/store';
import { useMemo } from 'react';

export function useStores() {
    const [stores] = storeService.allStores().useCache({ passive: true });
    return useMemo(() => ({ stores: stores ?? {}, isLoaded: !!stores }), [stores]);
}

export function useStoresList(): Store[] {
    const { stores } = useStores();
    return useMemo(() => Object.values(stores), [stores]);
}
